import React from 'react';
import { View } from 'react-native';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import { Button } from '@shared/components/md-design-system/Button/Button';
import { Text } from '@shared/components/text';
import { colorPalette } from '@shared/config/colorsConfig';
import { TDeviceIssueType } from 'app/types/deviceIssue';
import { DEVICE_ISSUE_CONFIG } from '../../constants/deviceIssueConfig';

export interface DeviceIssueCardProps {
  issueType: TDeviceIssueType;
  onPress: () => void;
}

export const DeviceIssueCard: React.FC<DeviceIssueCardProps> = ({ issueType, onPress }) => {
  const { t } = dynamicTranslations();
  const config = DEVICE_ISSUE_CONFIG[issueType];

  return (
    <View className="bg-warning-100 border border-warning-500 rounded-3xl p-4 flex-row gap-4">
      <View>
        <View className="w-[50px] h-[50px] border border-warning-500 rounded-xl bg-white items-center justify-center">
          <Icon name={config.icon} size={28} color={colorPalette.warning[700]} />
        </View>
      </View>
      <View className="flex-1">
        <Text className="font-bold text-black">{t(config.card.titleKey)}</Text>
        <Text className="font-normal text-black">{t(config.card.descriptionKey)}</Text>
        <Button variant="primary" onPress={onPress}>
          {t(config.card.ctaKey)}
        </Button>
      </View>
    </View>
  );
};
